export default __webpack_public_path__ + "static/media/foods.455dc2d1.jpg";